import Layout from 'components/common/Layout'
import * as SC from 'styles/contactsStyles'
import { ContactsGrid, PartnersGrid } from 'components/contactsPage'

import { BreadcrumbJsonLd, NextSeo } from 'next-seo'
import React from 'react'
const isSomeArrayNotEmpty = arrays => {
  const arrayOfBoolean = arrays?.map(array => {
    return array.partners.length === 0
  })
  return arrayOfBoolean?.includes(false)
}

const ContactsPage = ({ contacts, partners }) => {
  return (
    <Layout menuButtonColor="black">
      <>
        <NextSeo
          title="Контакты"
          description="Команда и партнеры фестиваля. Все важные контакты и полезные ссылки"
          canonical={`https://newopen.su/contacts`}
          openGraph={{
            url: 'https://newopen.su/contacts',
            title: 'История фестиваля | NEW / OPEN',
            description: 'Команда и партнеры фестиваля. Все важные контакты и полезные ссылки'
          }}
        />
        <BreadcrumbJsonLd
          itemListElements={[
            {
              position: 1,
              name: 'Главная',
              item: 'https://newopen.su/'
            },
            {
              position: 2,
              name: 'Контакты',
              item: 'https://newopen.su/contacts'
            }
          ]}
        />
        <SC.ContactsPageStyled>
          <SC.ContactsTitle>Контакты</SC.ContactsTitle>
          <SC.ContactsDescription>Контакты для СМИ, партнеров и участников</SC.ContactsDescription>

          <ContactsGrid contacts={contacts} />
          <div>
            {isSomeArrayNotEmpty(partners.groups) && <SC.ContactsSubtitle>Партнеры</SC.ContactsSubtitle>}
            {partners.groups?.map((group, index) => (
              <PartnersGrid name={group.name} partners={group.partners} key={group.code} index={index} />
            ))}
          </div>
        </SC.ContactsPageStyled>
      </>
    </Layout>
  )
}

export default ContactsPage
